var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowsMobileNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.72 4.62891C14.22 5.67141 15.255 7.32891 15.465 9.24141",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61755 9.27656C2.81255 7.37156 3.83255 5.71406 5.31755 4.66406",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14246 15.7031C7.01246 16.1456 8.00246 16.3931 9.04496 16.3931C10.05 16.3931 10.995 16.1681 11.8425 15.7556",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04496 5.77547C10.1965 5.77547 11.13 4.84198 11.13 3.69047C11.13 2.53895 10.1965 1.60547 9.04496 1.60547C7.89345 1.60547 6.95996 2.53895 6.95996 3.69047C6.95996 4.84198 7.89345 5.77547 9.04496 5.77547Z",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62248 14.9395C4.77399 14.9395 5.70748 14.006 5.70748 12.8545C5.70748 11.703 4.77399 10.7695 3.62248 10.7695C2.47096 10.7695 1.53748 11.703 1.53748 12.8545C1.53748 14.006 2.47096 14.9395 3.62248 14.9395Z",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3775 14.9395C15.529 14.9395 16.4625 14.006 16.4625 12.8545C16.4625 11.703 15.529 10.7695 14.3775 10.7695C13.226 10.7695 12.2925 11.703 12.2925 12.8545C12.2925 14.006 13.226 14.9395 14.3775 14.9395Z",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowsMobileNav);
export default __webpack_public_path__ + "static/media/flows-mobile-nav.c5a1f1c88bac83e0996a1ba47e7737b9.svg";
export { ForwardRef as ReactComponent };